import React from 'react';
import classnames from 'classnames';

import './groupInfoText.styl';
import data from '../../modules/infoSets';

const GroupInfoText = props => {
  const Text = props.currentDataSet ? data[props.currentDataSet] : 'Wählen Sie eine Teilgruppe aus der Seitenleiste aus';
  const TextClasses = classnames('ifdw-groupInfoText', {
    visible: props.currentDataSet
  });

  return (
    <div className={TextClasses}>
      {Text}
    </div>
  )
};

export default GroupInfoText;



/** WEBPACK FOOTER **
 ** ./src/components/GroupInfoText/index.js
 **/